
  document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.getElementById('custom_cart_agree');
  const checkoutBtn = document.querySelector('.cart__checkout-button');
  const errorMsg = document.querySelector('.custom__error-msg');

  if (checkbox && checkoutBtn && errorMsg) {
    checkoutBtn.addEventListener('click', function (e) {
      if (!checkbox.checked) {
        e.preventDefault();
        errorMsg.textContent = 'You must agree with terms and conditions before proceeding to checkout.';
        errorMsg.style.color = 'red';
        errorMsg.style.marginTop = '10px';
      } else {
        errorMsg.textContent = '';
      }
    });

    checkbox.addEventListener('change', function () {
      if (checkbox.checked) {
        errorMsg.textContent = '';
      }
    });
  }
});


// banner button click video popup 
$(".vpop").on('click', function(e) {
  e.preventDefault();
  $("#video-popup-overlay,#video-popup-iframe-container,#video-popup-container,#video-popup-close").show();
  
  var srchref='',autoplay='', id=$(this).attr('data-id');
  if($(this).data('type') == 'vimeo') 
    var srchref="//player.vimeo.com/video/";
  else if($(this).data('type') == 'youtube') 
  var srchref="https://www.youtube.com/embed/";
  
  if($(this).data('autoplay') == true) autoplay = '?autoplay=1';
  
var video =  $("#video-popup-iframe-container #video-popup-iframe").attr('src', srchref+id+autoplay);
  $("#video-popup-iframe").on('load', function() {
    $("#video-popup-container").show();
  });
});

$("#video-popup-close, #video-popup-overlay").on('click', function(e) {
  $("#video-popup-iframe-container,#video-popup-container,#video-popup-close,#video-popup-overlay").hide();
  $("#video-popup-iframe-container #video-popup-iframe").attr('src', '');
});

  // document.addEventListener("DOMContentLoaded", function () {
  //   const toggleBtn = document.querySelector(".read-more-toggle");
  //   const content = document.querySelector(".js-toggle-content");

  //   if (toggleBtn && content) {
  //     toggleBtn.addEventListener("click", function () {
  //       content.classList.toggle("expanded");
  //       toggleBtn.textContent = content.classList.contains("expanded")
  //         ? "Read Less"
  //         : "Read More";
  //     });
  //   }
  // });

$('.moreless-button').click(function() {
  $('.moretext').slideToggle();
  if ($('.moreless-button').text() == "Read More") {
    $(this).text("Read Less")
  } else {
    $(this).text("Read More")
  }
});


const buttons = document.querySelectorAll('.cart__ctas');

  function handleScroll() {
    const screenWidth = window.innerWidth;

    if (screenWidth > 480) {

      buttons.forEach(btn => btn.classList.remove('near-bottom'));
      return;
    }

    const scrollY = window.scrollY || window.pageYOffset;
    const windowHeight = window.innerHeight;
    const docHeight = document.documentElement.scrollHeight;
    const distanceFromBottom = docHeight - (scrollY + windowHeight);

    buttons.forEach(btn => {
      if (distanceFromBottom <= 50) {
        btn.classList.add('near-bottom'); 
      } else {
        btn.classList.remove('near-bottom'); 
      }
    });
  }

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);
  handleScroll();



  document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.read-more-toggle');
  const description = document.querySelector('.product-description');

  if (!toggle || !description) return;

  toggle.addEventListener('click', function () {
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    description.classList.toggle('is-collapsed');
    toggle.setAttribute('aria-expanded', String(!isExpanded));
    toggle.textContent = isExpanded ? 'Read more' : 'Read less';
  });
});